module.exports = __webpack_public_path__ + "static/media/harts_truck_start.1dc0b6f1.png";